export function autoOfflineDelay(minutes: number): number | undefined {
	if (!Number.isInteger(minutes) || minutes <= 0) return undefined;
	return minutes * 60_000;
}
